/// <reference path="../definitions/jquery/index.d.ts" />
/// <reference path="../public/irep.ts" />

declare var irep: IREP.IREP;
declare var Waypoint: any; // We should really add in waypoint types
declare var mtTrackComponent: boolean;

interface Window {
    mozRequestAnimationFrame: any;
}

namespace IREP {
    "use strict";

    export class Component {
        protected id: string;
        protected uid: string;
        protected $component: JQuery;

        private waypoint: any;

        constructor(id: string) {
            this.$component = $(id);
            this.uid = this.$component.data('controluid');

            if (this.uid != null) {
                this.waypoint = new Waypoint({
                    element: this.$component[0],
                    handler: (direction) => {
                        if (direction === "down") {
                            this.trackComponentView();
                            this.waypoint.destroy();
                        }
                    },
                    offset: 'bottom-in-view'
                });
            }
        }

        protected delay(timeout: number) {
            var deferred = $.Deferred();

            setTimeout(() => {
                deferred.resolve();
            }, timeout);

            return deferred.promise();
        }

        private requestAnimationFrameShim(callback) {
            window.setTimeout(callback, 1000 / 60);
        }

        protected requestAnimationFrame(callback) {
            const requestFn = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || this.requestAnimationFrameShim;

            requestFn.call(window, callback);
        }

        private trackComponentView() {
            if (mtTrackComponent) {
                irep.trackPage('ComponentViewed', this.uid, '', '');
            }
        }
    }
}
